import styled from 'styled-components'

export const Actions = styled.div`
  margin: 20px -20px -20px;
  padding: 15px 20px !important;
  border-radius: 0 0 3px 3px;
  background: ${props => props.theme.palette.general.soft};
  border-top: ${props => props.theme.palette.general.border};
  display: flex;
  justify-content: flex-end;

  button {
    min-width: 0;
    padding: 0 20px;
  }
`

export const ModalContent = styled.div`
  form {
    label {
      margin-top: 25px;
    }

    > div {
      padding: 0;
      position: relative;

      input + span,
      textarea + span {
        position: static !important;
        height: auto !important;
        margin: 5px 0 0;
        display: none !important;
      }

      > div {
        padding: 0;
      }

      &:first-child {
        label {
          margin-top: 0;
        }
      }
    }
  }

  > p {
    font-size: 18px;
  }

  label {
    font-size: 19px;
    margin-bottom: 4px;
    display: block;

    em {
      margin-left: 5px;
    }

    span {
      cursor: pointer;
    }

    .label-note {
      margin-left: 3px;
      font-size: 12px;
      color: ${props => props.theme.palette.general.greyDark};
    }
  }

  textarea,
  select,
  input {
    ${props => props.theme.css.formInputDefaultStyles};
  }

  textarea {
    height: 120px;
  }

  .ratings {
    > div {
      height: 40px;
      line-height: 40px;
      margin-top: -5px;
    }

    .react-rater-star {
      width: 22px;
      height: 22px;
      background-size: 22px;
    }
  }

  .captcha {
    margin-top: 20px;
  }
`
